import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import authRoutes from '@/router/auth'
import profileRoutes from '@/router/profile'
import projectRoutes from '@/router/project'

const anyRoutes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/HomeView.vue')
  },
  {
    path: '/ui',
    name: 'ui',
    component: () => import('@/views/UIView.vue')
  }
]

const routes = [...anyRoutes, ...authRoutes, ...profileRoutes, ...projectRoutes]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior () {
    return { top: 0 }
  }
})

export default router
